(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectsConditions', TabObjectsConditions);

    TabObjectsConditions.$inject = ['$resource'];

    function TabObjectsConditions($resource) {
        var resourceUrl = 'api/tab-objects-conditions/:name';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'default': {url: 'api/tab-objects-conditions-default', method: 'GET'},
            'checkTest': {url: 'api/tab-objects-conditions-check/:id', method: 'GET', isArray: true}
        });
    }
})();
